module.exports = __webpack_public_path__ + "static/media/cover-photo.c9f67286.png";